import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import cn from 'classnames';

import { sendSupport } from '../../actions/auth';
import { Input, Textarea } from '../../components/FormsControls/FormControls';
import styles from './Support.module.css';

const SupportSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  message: Yup.string().required('Required'),
});

const Support = (props) => {
  const { sendSupport } = props;

  const submitHandler = (supportData, { resetForm }) => {
    sendSupport(supportData, () => {
      toast.success('Your request has been submitted, please wait for a response.', {
        position: 'bottom-right',
        duration: 3000,
      });
      resetForm();
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Link 
          className={'back-button'} 
          to="/" 
        />

        <div className="medium-text">
          Support
        </div>
        <Formik
          onSubmit={submitHandler}
          initialValues={{ name: '', email: '', message: '' }}
          validationSchema={SupportSchema}
        >
          <Form className={styles.form}>
            <Input
              className={styles.input}
              name="name"
              placeholder="Name"
            />
            <Input
              className={styles.input}
              name="email"
              placeholder="Email"
            />
            <Textarea
              className={cn(styles.input, styles.textarea)}
              name="message"
              placeholder="Description"
            />
            <button className="green-button">
              Submit
            </button>
          </Form>
        </Formik>
        <div className={styles.supportEmail}>
          Support email:{' '}
          <a 
            className={styles.supportEmailLink} 
            href="mailto:hello@mealwell.ai"
          >
            hello@mealwell.ai
          </a>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  sendSupport,
};

export default connect(null, mapDispatchToProps)(Support);
